import * as React from "react";
import { Body1, makeStyles } from "@fluentui/react-components";
import { EventLogEntry } from "../../services/eventLogger";
import { eventLogger } from "../index";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    height: "100%",
    minHeight: 0,
  },
  eventLog: {
    fontSize: "12px",
    fontFamily: "monospace",
    padding: "8px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    flex: "1 1 0",
    minHeight: 0,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
  }
});

const EventsTab: React.FC = () => {
  const styles = useStyles();
  const [logs, setLogs] = React.useState<EventLogEntry[]>([]);
  const logContainerRef = React.useRef<HTMLDivElement>(null);

  // Subscribe to the centralized event logger
  React.useEffect(() => {
    const unsubscribe = eventLogger.subscribe((updatedLogs) => {
      setLogs(updatedLogs);
    });

    return unsubscribe;
  }, []);

  // Auto-scroll to bottom when new logs are added
  React.useEffect(() => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div className={styles.container}>
      <div className={styles.eventLog} ref={logContainerRef}>
        {logs.length === 0 ? (
          <Body1>No events yet...</Body1>
        ) : (
          logs.map((log) => {
            const timestamp = new Date(log.timestamp).toLocaleTimeString();
            return (
              <div key={log.id}>
                [{timestamp}] {log.namespace ? `${log.namespace}.` : ""}{log.type}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default EventsTab;
